import { MoreVertical, User } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useRef } from "react";
import { convertWeightToHumanReadable } from "@/Utilities/Utilities";
import { Inertia } from "@inertiajs/inertia";
import { InertiaLink } from "@inertiajs/inertia-react";
import Placeholder from "../Placeholder";
import { useLoading } from "@/Contexts/LoadingContext";
import { Teams } from "@/Icons";
import ShrinkableTagRow from "@/Components/ShrinkableTagRow";
import classNames from "classnames";

const Row = ({
  question,
  team,
  emission = null,
  onDelete = () => null,
  isNew = false,
  isReporter = false,
}) => {
  const { isLoaded } = useLoading();

  const actionMenuItems = [
    {
      label: "Report on activity",
      callback: () =>
        Inertia.visit(
          route("team.question.report", {
            team: team.id,
            question: question.id,
          }),
        ),
    },
  ];
  if (!isReporter) {
    actionMenuItems.push(
      {
        label: "Edit activity",
        callback: () =>
          Inertia.visit(
            route("question.edit", { team: team.id, question: question.id }),
          ),
      },
      {
        label: "Delete activity",
        callback: () => onDelete(question.id, team.id),
      },
    );
  }

  const actionMenuRef = useRef(null);
  const currentYear = new Date().getFullYear();

  return (
    <InertiaLink
      href={route("team.question.report", {
        team: team.id,
        question: question.id,
      })}
      className={`shadow-small grid min-h-[53px] cursor-pointer grid-cols-4 gap-2 bg-gray-light p-4 md:grid-flow-col-dense md:grid-cols-12 md:p-8 md:px-4 md:py-2 ${
        isNew ? "slide-in-top-fade-bg-green" : ""
      }`}
    >
      <div className="col-span-3 flex items-center max-md:order-first md:col-span-5">
        <h3
          className={classNames("truncate leading-none", {
            "font-bold ": question.is_published,
          })}
          title={question.title || "(Untitled)"}
        >
          {question.title || "(Untitled)"}
          {!question.is_published && <span> - Draft</span>}
        </h3>
      </div>
      {!isReporter && <ShrinkableTagRow tags={question.tags} />}
      <div className="col-span-2 flex items-center md:col-span-2">
        {isLoaded ? (
          emission && (
            <div className="rounded-md bg-blue-lighter px-3 py-2 font-overpass text-sm leading-none">
              {convertWeightToHumanReadable(emission.total, true)?.concat} CO₂e
              ({currentYear})
            </div>
          )
        ) : (
          <Placeholder width="100px" height="32px" />
        )}
      </div>
      {isReporter && (
        <div className="col-span-2 flex items-center md:col-span-2">
          <p className="text-sm leading-none">
            Reported:{" "}
            {question?.last_reported
              ? question?.last_reported.substr(0, 10)
              : "Not reported"}
          </p>
        </div>
      )}
      {isReporter ? ( // reporters always show their user so show team insead
        <div className="col-span-2 flex justify-end md:col-span-2 md:justify-start">
          <p className="color-black flex w-full flex-row items-center text-sm">
            <Teams className="mr-2" />
            <span
              className="inline-block w-full truncate"
              title={question?.pivot?.team_id ? `${team.name}` : "No team"}
            >
              {question?.pivot?.team_id ? `${team.name}` : "No team"}
            </span>
          </p>
        </div>
      ) : (
        <div className="col-span-2 flex justify-end md:col-span-2 md:justify-start">
          <p className="color-black flex flex-row items-center text-sm">
            <User className="mr-2" />
            {question?.pivot?.user
              ? `${
                  question.pivot.user.firstname
                } ${question.pivot.user.surname.charAt(0)}`
              : "No reporter"}
          </p>
        </div>
      )}
      <div
        className="col-span-1 flex items-center justify-end max-md:order-first md:order-last md:col-span-1"
        onClick={(e) => {
          e.preventDefault();
          actionMenuRef.current.toggleMenu();
        }}
      >
        <div className="hover-circle relative z-10 ml-2">
          <MoreVertical size={24} className="shrink-0 cursor-pointer" />
          <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
        </div>
      </div>
    </InertiaLink>
  );
};

export default Row;
